import z from "zod";

const count = z.number().int().nonnegative();

/**
 * The counts the In use tab of the fee schedules page shows, from `GET /work/fee-schedules/counts`
 * (#6709): the fee schedules of current work, and those of archived work (#6716). Each takes the
 * list's own criteria.
 */
export const FeeScheduleListCountsJSONZ = z.object({
  active: count,
  archived: count,
});

export type FeeScheduleListCounts = z.infer<typeof FeeScheduleListCountsJSONZ>;
